import { dataTableOffers } from '../config/mockData';


/***************************************************************************************************************************************************************
 * ROLES
 * 
 */
var portfolioList = [{
    id:"srthsathstaerht",
    name: "Summer",
    validFor: ["HW", "Sim"],
    note: "",
    active: true,
    tariffs: [{
        key: "4h6346h356h356h",
        package: 20,
        type: "30",
        level: "T1",
        price: 100000,
        subsidy: 12
    },{
        key: "4h634fd6h356h356h",
        package: 20,
        type: "31",
        level: "T1",
        price: 120000,
        subsidy: 10
    },{
        key: "44fd6h356h356h",
        package: 20,
        type: "30",
        level: "T2",
        price: 140000,
        subsidy: 8
    }],/*{ key, name, type, level, price, subsidy }*/
    options: [{
        key: "gdasgea4g",
        group: "srfghw456htsdtyrk", 
        value: "1GB", 
        price: 50000
    },{
        key: "gdasgena4g",
        group: "srfghw456htsdtyrk", 
        value: "2GB", 
        price: 20000
    },{
        key: "gdasasagea4g",
        group: "srfghw456htsdtyrk", 
        value: "3GB", 
        price: 25000
    },{
        key: "gdasgea4dhgfg",
        group: "wsrtyj546ehrs1", 
        value: "10GB", 
        price: 100000
    },{
        key: "gdsdsasgea4g",
        group: "wsrtyj546ehrs1", 
        value: "20GB", 
        price: 200000
    },{
        key: "gdadsghgea4g",
        group: "wsrtyj546ehrs1", 
        value: "3GB", 
        price: 280000
    }]/*{ key, group, value, price }*/
},{
    id:"srthsasfdgthstaerht",
    name: "Custom",
    validFor: ["HW", "Sim"],
    note: "",
    active: true,
    tariffs: [{
        key: "4h6q1346h356h356h",
        package: 21,
        type: "30",
        level: "T3",
        price: 100000,
        subsidy: 12
    },{
        key: "4h634fd6hdsw356h356h",
        package: 23,
        type: "31",
        level: "T1",
        price: 120000,
        subsidy: 10
    },{
        key: "44fd6hdad356h356h",
        package: 21,
        type: "30",
        level: "T7",
        price: 140000,
        subsidy: 8
    }],/*{ key, name, type, level, price, subsidy }*/
    options: [{
        key: "gdasgea4g",
        group: "srfghw456htsdtyrk", 
        value: "1GB", 
        price: 50000
    },{
        key: "gdasasagea4g",
        group: "srfghw456htsdtyrk", 
        value: "3GB", 
        price: 25000
    },{
        key: "gdasgea4dhgfg",
        group: "wsrtyj546ehrs1", 
        value: "10GB", 
        price: 100000
    }]/*{ key, group, value, price }*/
},{
    id:"srthdasdsathstaerht",
    name: "Business",
    validFor: ["HW", "Sim"],
    note: "",
    active: true,
    tariffs: [{
        key: "4h6q1346h356h3ghg56h",
        package: 21,
        type: "30",
        level: "T3",
        price: 100000,
        subsidy: 12
    },{
        key: "fjghjftyhffghg",
        package: 20,
        type: "31",
        level: "T2",
        price: 120000,
        subsidy: 10
    }],/*{ key, name, type, level, price, subsidy }*/
    options: [{
        key: "gdasgena4g",
        group: "srfghw456htsdtyrk", 
        value: "2GB", 
        price: 20000
    },{
        key: "gdasasagea4g",
        group: "srfghw456htsdtyrk", 
        value: "3GB", 
        price: 25000
    },{
        key: "gdsdsasgea4g",
        group: "wsrtyj546ehrs1", 
        value: "20GB", 
        price: 200000
    },{
        key: "gdadsghgea4g",
        group: "wsrtyj546ehrs1", 
        value: "3GB", 
        price: 280000
    }]/*{ key, group, value, price }*/
},{
    id:"srthsathstaerhfdgdt",
    name: "Matrix",
    validFor: ["Sim"],
    note: "",
    active: true,
    tariffs: [{
        key: "4h6q134fhdj6h356h3ghg56h",
        package: 20,
        type: "31",
        level: "T1",
        price: 100000,
        subsidy: 12
    },{
        key: "fjghjftsadyhffghg",
        package: 20,
        type: "32",
        level: "T2",
        price: 90000,
        subsidy: 10
    },{
        key: "44fd6hdad3vcsx5n6h356h",
        package: 23,
        type: "30",
        level: "T7",
        price: 140000,
        subsidy: 8
    },{
        key: "44fd6hdad35n6h356h",
        package: 20,
        type: "30",
        level: "T4",
        price: 140000,
        subsidy: 8
    }],/*{ key, name, type, level, price, subsidy }*/
    options: [{
        key: "gdasgea4g",
        group: "srfghw456htsdtyrk", 
        value: "1GB", 
        price: 50000
    },{
        key: "gdasgea4dhgfg",
        group: "wsrtyj546ehrs1", 
        value: "10GB", 
        price: 100000
    },{
        key: "gdadsghgea4g",
        group: "wsrtyj546ehrs1", 
        value: "3GB", 
        price: 280000
    }]/*{ key, group, value, price }*/
},{
    id:"srtxzczxhsathstaerht",
    name: "Mozaik",
    validFor: ["HW", "Sim"],
    note: "",
    active: false,
    tariffs: [{
        key: "4h6q1vbc34fhdj6h356h3ghg56h",
        package: 20,
        type: "31",
        level: "T1",
        price: 100000,
        subsidy: 12
    },{
        key: "fjghjfzxtsadyhffghg",
        package: 20,
        type: "32",
        level: "T2",
        price: 90000,
        subsidy: 10
    },{
        key: "44fd6hdad3vcxvcsx5n6h356h",
        package: 23,
        type: "30",
        level: "T7",
        price: 140000,
        subsidy: 8
    }],/*{ key, name, type, level, price, subsidy }*/
    options: [{
        key: "gdasgea4g",
        group: "srfghw456htsdtyrk", 
        value: "1GB", 
        price: 50000
    },{
        key: "gdasgena4g",
        group: "srfghw456htsdtyrk", 
        value: "2GB", 
        price: 20000
    },{
        key: "gdasgea4dhgfg",
        group: "wsrtyj546ehrs1", 
        value: "10GB", 
        price: 100000
    },{
        key: "gdsdsasgea4g",
        group: "wsrtyj546ehrs1", 
        value: "20GB", 
        price: 200000
    },{
        key: "gdadsghgea4g",
        group: "wsrtyj546ehrs1", 
        value: "3GB", 
        price: 280000
    }]/*{ key, group, value, price }*/
}]


/***************************************************************************************************************************************************************
 * ROLES
 * 
 */

var roles = [
    {
        id: "dhfjt544645hg534h",
        name: "Administrator",
        system: {
            id:"adfghaeghd", 
            name: "Sugar CRM",
            groups: [ 
                "Regional Manager North",
                "Regional Manager East",
                "Regional Manager South",
                "Regional Manager West"
            ]
        },
    },
    {
        id: "4h46jhrteh5hgrteh",
        name: "Manager",
        system: {
            id:"adfghaeghd", 
            name: "Sugar CRM",
            groups: [ 
                "Manager North"
            ]
        },
    },
    {
        id: "45y45gheg354g",
        name: "RegionalManager",
        system: {
            id:"adfghaeghd", 
            name: "Sugar CRM",
            groups: [ 
                "Regional Manager North",
                "Regional Manager East",
                "Regional Manager South",
                "Regional Manager West"
            ]
        }
    },
    {
        id: "34534sdf43fc",
        name: "AccountManager",
        system: {
            id:"adfghaeghd", 
            name: "Sugar CRM",
            groups: [ 
                "Account Manager North",
                "Account Manager South"
            ]
        }
    },
    {
        id: "435h456h3543hjyrj",
        name: "Partner",
        system: {
            id:"adfghaeghd", 
            name: "Sugar CRM",
            groups: [ 
                "Regional Manager East",
                "Regional Manager South"
            ]
        },
    }
]

/***************************************************************************************************************************************************************
 * OFFERS
 * 
 */

var offerParams = {
    offerDuration: [12, 24, 36],
    offerType:[{
        id:1,
        name: "Renewal",
        discount: 10
    },{
        id:2,
        name: "Acquisition",
        discount: 12
    },{
        id:3,
        name: "Add HW",
        discount: 8
    },{
        id:4,
        name: "Change of Terms",
        discount: 5
    }],
    portfolio: [{
        id:10,
        name: "National Voice"
    },{
        id:11,
        name: "National Voice Summer"
    },{
        id:12,
        name: "Unlimited"
    }],
    options: [
        {
            id: "srfghw456htsdtyrk",
            name: "Internet",
            values: [
                {id:"gsfgwre", name:"1GB", price:1750},
                {id:"gsffdgwre", name:"3GB", price:4000},
                {id:"gsfsdggwre", name:"5GB", price:5500}
            ],
        },
        {
            id: "wsrtyj546ehrs1",
            name: "Podeli Net",
            values: [
                {id:"gs32fgwre", name:"10GB", price:3000},
                {id:"gssdf23fgwre", name:"20GB", price:5500},
                {id:"gsfg4rvdwre", name:"30GB", price:7250}
            ],
        }
    ]
    // options: [
    //     {
    //         id: "srfghw456htsdtyrk",
    //         name: "Internet",
    //         values: ["1GB", "3GB", "5GB"],
    //     },
    //     {
    //         id: "wsrtyj546ehrs1",
    //         name: "Podeli Net",
    //         values: ["10GB", "20GB", "30GB"],
    //     }
    // ]
}
var offerPackage = {
    packages:[{
        id: 20,
        name: "biz 8",
        description:"-",
        price: 160000
    },{
        id: 21,
        name: "biz 16",
        description:"-",
        price: 120000
    },{
        id: 22,
        name: "biz 24",
        description:"-",
        price: 250000
    },{
        id: 23,
        name: "biz 32",
        description:"-",
        price: 280000
    }],
    type:[{
        id: 30,
        name: "HW"
    },{
        id: 31,
        name: "Sim"
    }],
    hardware:[{
        id: 40,
        name: "Apple iPhone 12 64",
        description:"White",
        price: 750000,
    }, {
        id: 41,
        name: "Samsung Galaxy S21",
        description:"Black",
        price: 815000,
    }],
    internetDodatak:[{
        id: 50,
        name: "1 GB",
        description: null,
        price: 3000,
    }, {
        id: 51,
        name: "3 GB",
        description: null,
        price: 8000,
    }, {
        id: 52,
        name: "5 GB",
        description: null,
        price: 10000,
    }],
    podeliNet: [{
        id: 61,
        name: "10 GB",
        description: null,
        price: 9500,
    }, {
        id:62,
        name: "20 GB",
        description: null,
        price: 18000,
    }, {
        id: 63,
        name: "30 GB",
        description: null,
        price: 26000,
    }]
}

var portfolioConfig = {
    validFor: [
        {
            id: 30,
            name: "HW"
        },{
            id: 31,
            name: "Sim"
        }
    ],
    tariffs: {
        packages: offerPackage.packages,
        type: offerPackage.type,
        level: ["T1", "T2", "T3", "T4", "T5", "T6", "T7"]
    },
    options: [
        {
            id: "srfghw456htsdtyrk",
            name: "Internet",
            values: ["1GB", "3GB", "5GB"],
        },
        {
            id: "wsrtyj546ehrs1",
            name: "Podeli Net",
            values: ["10GB", "20GB", "30GB"],
        }
    ]
}

const getData = (url, query) => {
    switch(url) {
        case "/api/offer":
            return { ...offerParams };

        case "/api/offer/profile/":
            return [...offerPackage.packages];

        case "/api/offer/package/":
            const { type, hardware, internetDodatak, podeliNet } = offerPackage;
            return { type, hardware, internetDodatak, podeliNet };

        case "/api/user/roles":
            return JSON.parse(JSON.stringify(roles));

        case "/api/portfolios/":
            return JSON.parse(JSON.stringify(portfolioList));

        case "/api/portfolio/config":
            return JSON.parse(JSON.stringify(portfolioConfig));
        
        case "/api/offer/search":
            return dataTableOffers();

        default:
            return [];
    }
    // if (query) url += "?" + new URLSearchParams(query).toString();
    // return fetch(url)
    //     .then(response => response?.json())
    //     .catch(err => console.log(err.response));
}

const postData = (url, payload) => {
    // payload.statusMessage = "";
    
    return Object.keys(payload).reduce((res, k) => res && (!!payload[k] || payload[k] === false || !isNaN(parseInt(payload[k]))), Object.keys(payload).length > 0);
    // return fetch(url, {
    //     method: 'POST',
    //     body: payload
    //   })
    //   .then(response => response?.json())
    //   .catch(err => console.log(err.response));
}

export { getData, postData };


// class ApiService {
//     loginUser = () => {
//         return fetch("/api/auth", {
//             headers: {
//                 Authorization: `Bearer ${this.token}`,
//             },
//         }).then((res) => res.json());
//     };
// }

// const api = new ApiService();
// api.token = localStorage.token;

// export default api;
